export default __webpack_public_path__ + "0ea98112bb23e1e07d7243ac30cce082.svg";